import {
  Component,
  Input,
  HostListener,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "icn-segment-button",
  templateUrl: "./segment-button.component.html",
  styleUrls: ["./segment-button.component.scss"],
  host: {
    "[class.active]": "isActive",
    "(click)": "onClick($event)",
  },
})
export class SegmentButtonComponent {
  @Input()
  icon: string;

  @Input()
  value: any;

  @Output()
  icnClick = new EventEmitter<SegmentButtonComponent>();

  private isActive: boolean;

  set active(isActive: boolean) {
    this.isActive = isActive;
  }

  get active() {
    return this.isActive;
  }

  onClick() {
    this.icnClick.emit(this);
  }
}
